import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=0b03b890&scoped=true"
var script = {}
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=0b03b890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b03b890",
  null
  
)

export default component.exports